export const FIELD_NAMES = {
  SCROLL_X: 'scrollX',
  SCROLL_Y: 'scrollY',
  SCROLL_DIRECTION: 'scrollDirection',
  SCROLL_EDGE: 'scrollEdge',
  SCROLL_TO: 'scrollTo',
  SCROLL_INSIDE: 'scrollInside',
};
